/**
 * The inactivity sign-out's BroadcastChannel and shared input clock in this
 * app (IdleSignOut from @aaimplatform/ui, DCF-62). PlatformAdminLayout mounts it with
 * this name, and the auth store resets the clock when the app starts with no
 * session. A module of its own, so a test that mocks the auth store keeps it.
 */
export const IDLE_SIGN_OUT_CHANNEL = 'platform-admin-activity';
